export default __webpack_public_path__ + "89dfba1e710157442c678658057cc603.svg";